const initialState = {
    user: null,
    token: localStorage.getItem('token'),
    loading: false,
    error: null,
    isAuthenticated: !!localStorage.getItem('token')
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        // Loading states
        case 'AUTH_START':
        case 'SIGNUP_START':
        case 'UPDATE_PROFILE_START':
            return {
                ...state,
                loading: true,
                error: null
            };

        // Success states
        case 'AUTH_SUCCESS':
        case 'SIGNUP_SUCCESS':
            localStorage.setItem('profile', JSON.stringify(action.payload));
            return {
                ...state,
                user: action.payload.user,
                token: action.payload.token,
                loading: false,
                error: null,
                isAuthenticated: true
            };



        case 'UPDATE_PROFILE_SUCCESS':
            return {
                ...state,
                user: action.payload,
                loading: false,
                error: null
            };

        // Failure states
        case 'AUTH_FAIL':
        case 'SIGNUP_FAIL':
            localStorage.removeItem('profile');
            return {
                ...state,
                user: null,
                token: null,
                loading: false,
                error: action.payload,
                isAuthenticated: false
            };

        case 'UPDATE_PROFILE_FAIL':
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case 'LOGOUT':
            localStorage.removeItem('profile');
            return {
                ...state,
                user: null,
                token: null,
                loading: false,
                error: null,
                isAuthenticated: false
            };

        case 'AUTH':
            localStorage.setItem('profile', JSON.stringify({ ...action?.data }));
            return { ...state, authData: { ...action?.data }};

        default:
            return state;
    }
};

export default authReducer;